module.exports = __webpack_public_path__ + "img/console13.3cd5e8ae.jpg";